import { useState, useEffect } from 'react';
import {
  sleep, getProvisioningItems, updateProvisioningItem, reFetchAndDispatchItem,
} from 'utils';
import { service } from 'services';
import { useSelector } from 'react-redux';

const defaultFetchingTime = 5000;
const initialItems = getProvisioningItems();

export const useProvisoningStatus = () => {
  const { provisioningItems = [] } = useSelector((e) => e);
  const [items, setItems] = useState(initialItems);

  const fetch = async () => {
    let localItems = getProvisioningItems();
    localItems = localItems.filter(({ status }) => status !== 'DONE' && status !== 'FAILED');

    if (localItems.length > 0) {
      let globalStatus = false;
      // eslint-disable-next-line no-unused-vars
      for (const localItem of localItems) {
        const {
          id, url, status: outerStatus, type, action,
        } = localItem;
        const result = await service.common.getUrl({ url });
        const { metadata = {} } = result || {};
        const { status: innerStatus, message } = metadata;
        // const { status: innerStatus, message, targets = [] } = metadata;
        // const [target] = targets;
        // const { status: itemStatus, target: { id: targetId, type, href: itemUrl } } = target;
        if (innerStatus === 'DONE') {
          reFetchAndDispatchItem({ type: `${type}-${action}`, id });
        }

        if (innerStatus !== outerStatus) {
          updateProvisioningItem({ id, item: { ...localItem, status: innerStatus, message } });
        } else {
          globalStatus = true;
        }

        await sleep(1000);
      }

      if (globalStatus) {
        sleep(defaultFetchingTime, () => fetch());
      }
    }

    setItems(getProvisioningItems());
  };

  const updateTheItems = () => {
    setItems(getProvisioningItems());
    fetch();
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateTheItems();
    // eslint-disable-next-line
  }, [provisioningItems]);
  return [items];
};
